var _use, _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 67 67",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.227,
    cy: 33.242,
    rx: 33.227,
    ry: 33.242,
    style: {
      fill: "url(#_Linear1)"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 18.347,
    y: 7.091,
    width: "33.321px",
    height: "54.318px",
    transform: "matrix(0.980015,0,0,0.987602,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.012,31.838l7.251,1.635l-20.676,21.409l7.855,-20.237l-7.252,-1.635l20.677,-21.409l-7.855,20.237Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d1c8ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b5cfff",
      stopOpacity: 1
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "34px",
    height: "55px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAA3CAYAAABpXJjqAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAC+UlEQVRYhb2Z0ZGcMBBEezEXlFNwHo7q8rgULigb8A+jbbV6QNoFq0rF1nKFnnpGPcMe8B/Hz1+/H9m99MbdCwPA99fndjsIQWRrbAxzC4hAxFSImPj++tzmGyEmAXnEwgBWgbpWEQMxCVCosNLcAOAyRQTCTRBEfC4qXQKSQPzYZygCA4GAeRskCUdAzKjV4Gs13gIxEAzAigCUDw7sZZATCAZ57BDx9+XY4t3j2wERIBPqpNRZxjBIJ8RM9zlBIzwNzBCIcUyF+ECdGxwC9pDKVYdABEJPRkBwSBxABcGjC8RAKEhAcEhYjRWtm25cfU9BEojYOQPEd3w6LACMIpN+0QERSgSEhkSPaQbTB3IAwYszBIMowAJRg8OSgpxAuOTkkIQaqoQ6azUakA6IjwMlAsKV+jQ/GpBOCLVw7jdYjQymCYtVhB6aQahpsRoBwsros21TXUD2mwzhTEuVUAiF0c0V5RQmU2QUQmF0Q9oyNjCzfKHkruVzXTnDOFU1UbkQNopkDzrauYPJ1FTTq1Q5snjXP/DMVGEYLXoTnk3SafPsKiZPbnJicb2ehbXZBINoJ8X2rLnDO8pUyaYdE1AZDEMsAP7KXPZ5aNf0rLhm1TdtAzSrH3gqEvHVB+kudTOHrUCIUE6NUaW3hLudLzS71KwMLYGxNm1gFCILqd3QSPOcJZ2GYgHwZweIa8Ckxa+xeKmMzti00o5AlLBoBW4UkeKXuayCaDiGIKwiokZWuGIoBAN0QzSKmOIXVq0gzm80JN0QDUiHEi4kb0OcgTgYhlgNhDumpxAVSNKhHUHoCXkZogKhoTDOM7IaVDlnL0QBSZJUQdg9T4vhCEQBEYjMPdnCHcTh68IISAYTEEBrXAyxvgqhIBoeoK3EDHIZBADM8n7hwhEPX8y8BAJ4KuKaG/29PJLxcggG4QUZgjs29xPDJRAMol1WfHbNdMmbqyCA+iWHPYQTVxP2UiVi6OsEUP9KzPcuDwePsuDov75uAxGYZtwFEOMf7x1BgtgTX/4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlash);
export default __webpack_public_path__ + "static/media/icon-flash.ae053c8be85595d1a45f650592f41b9e.svg";
export { ForwardRef as ReactComponent };